import { Component, Input } from '@angular/core';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { Produto } from 'src/app/core/models/produto.model';

@Component({
  selector: 'app-novo-pedido-outros-servicos',
  templateUrl: './novo-pedido-outros-servicos.component.html',
  styleUrls: ['./novo-pedido-outros-servicos.component.scss']
})
export class NovoPedidoOutrosServicosComponent {
  @Input() comboOutrosServicos: Produto[] = [];
  @Input() servicosAdicionados: Produto[] = [];
  @Input() legend: string;

  servicoSelecionado: any;
  quantidadeAdd: number = 1;

  comboOutrosServicosFiltrado: Produto[] = [];

  filterAutoComplete(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.comboOutrosServicosFiltrado = this.comboOutrosServicos.filter(x => 
      x.descricao.toLowerCase().includes(query.toLowerCase()) ||
      x.cod_produto.toString().includes(query)
    );
  }

  adicionarServico() {
    if (this.servicoSelecionado) {
      this.servicoSelecionado.quantidadeAdd = this.quantidadeAdd;
      this.servicosAdicionados.push(this.servicoSelecionado);
    }

    this.servicoSelecionado = null;
    this.quantidadeAdd = 1;
  }

  deletarServico(servico: any, index: any) {
    this.servicosAdicionados.splice(index, 1);
  }
}